// 1. IMPORTS
import pickBy from "lodash/pickBy";

// 3. PURE HELPERS
const removeEmptyValues = (value = {}) =>
  pickBy(value, (item) => item !== "" && item !== undefined);

// 9. EXPORTS
export { removeEmptyValues };